import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import { themes } from '@/utils/theme'

Vue.use(Vuetify);

// export default new Vuetify({
//   theme: {
//     themes: {
//       light: {
//         primary: '#ee44aa',
//         secondary: '#424242',
//         accent: '#82B1FF',
//         error: '#FF5252',
//         info: '#2196F3',
//         success: '#4CAF50',
//         warning: '#FFC107'
//       },
//     },
//   },
//   icons: {
//     iconfont: 'mdi',
//   },
// });

export default new Vuetify({
    theme: {
      themes: {
        light: themes[0],
        dark: themes[0]
      }
    },
    icons: {
      iconfont: 'mdi',
    },
});